import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';

export interface UploadFileVars {
    data: {
        file: any,
        type?: number
        type_id?: number
        attribute?: string,
    };
}

interface UploadFileData {
    uploadFile: any
}

export const UPLOAD_FILE_MUTATION = gql`
    mutation uploadFile($data: UploadInput!) {
        uploadFile(data: $data)
    }
`;

export const uploadFile = () => useMutation<UploadFileData, UploadFileVars>(
    UPLOAD_FILE_MUTATION,
);

export default uploadFile;